import { render, staticRenderFns } from "./TipoContactoPantalla.vue?vue&type=template&id=5de2162c&"
import script from "./TipoContactoPantalla.vue?vue&type=script&lang=ts&"
export * from "./TipoContactoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5de2162c', component.options)
    } else {
      api.reload('5de2162c', component.options)
    }
    module.hot.accept("./TipoContactoPantalla.vue?vue&type=template&id=5de2162c&", function () {
      api.rerender('5de2162c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoContacto/TipoContactoPantalla.vue"
export default component.exports